module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "news-title",
    class: {
      'news-subtitle': _vm.subtitle, 'news-title--no-top': _vm.margin.top
    },
    attrs: {
      "id": _vm.id
    }
  }, [_vm._t("default", [_vm._v("Heading content")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fde53c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/news/news-heading.vue
// module id = 54
// module chunks = 4 5